/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Sort,
  Search,
  Filter,
  Page,
  Resize,
  Edit,
  Inject,
  Toolbar,
  ExcelExport,
  ContextMenu,
  ForeignKey,
  LazyLoadGroup,
  Group,
  SortSettings,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';
import { UploaderComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { useStateContext } from '../contexts/ContextProvider';
import { contextMenuItems, organizationsGrid, gridLatLngOrganization } from '../data/dummy';
import { Header, Configuration, InventoryContent, Spreadsheet, SMS } from '../components';
import scribeHow from '../data/scribehow.png';
import orgchart from '../data/orgchart.png';
import './Zackat.css';

const Organizations = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=organizations');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    boss,
    setBoss,
    zRenderMode,
    isMobile,
    collapseConfiguration,
    setCollapseConfiguration,
    parentOrgs,
  } = useStateContext();

  const { REACT_APP_API_ENDPOINT } = process.env;
  // const [orgData, setOrgData] = useState(null);
  const [otaData, setOtaData] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [enableRecordings, setRecordings] = useState(true);
  const [enableOTA, setOTA] = useState(true);
  const [billit, setBillIt] = useState(false);
  const [enableTasks, setEnableTasks] = useState(true);
  const [enableCfg, setCfg] = useState(true);
  const [enableJobs, setJobs] = useState(true);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [taskData, setTaskData] = useState([]);
  const [cfgDialog, setCfgDialog] = useState(true);
  const [ssDialog, setSSDialog] = useState(true);
  const [invDialog, setInvDialog] = useState(true);
  const [config, setConfig] = useState(false);
  const [band, setBand] = useState(false);
  const [esms, setESMS] = useState(false);
  const [etasks, setETasks] = useState(false);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [crudImport, setCrudImport] = useState(false);
  const [development, setDevelopment] = useState(false);
  const [selNewTask, setNewTask] = useState('');
  const [hideDialog, setDialog] = useState(true);
  const [smsDialog, setSMSDialog] = useState(true);
  const [organization, setOrganization] = useState(null);
  const [disabledRemove, setDisabledRemove] = useState(true);
  const [loadInventory, setLoadInventory] = useState('');
  const [reloadInventory, setReLoadInventory] = useState(false);
  const [inventory, setInventory] = useState([]);

  const grid = useRef(null);
  const dataBound = (args) => {
    if (grid && grid.current) {
      grid.current.toolbarModule.toolbar.overflowMode = 'MultiRow';
    }
  };
  const [categoryData, setCategoryData] = useState([{ text: 'Not Specifified', value: 'na' }]);
  const categoryParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(categoryData),
      fields: { text: 'model', value: '_id' },
      query: new Query(),
    },
  };

  const valuerules = { required: true };
  /*
  useEffect(() => {
    setReload(!reload);
  }, [parentOrgs]);
  }
  */
  useEffect(() => {
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Import')) {
      setCrudImport(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
    if (data && data.role && data.role.roles && data.role.roles.permissions.includes('Development')) {
      setDevelopment(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Configuration')) {
      setConfig(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Band')) {
      setBand(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('SMS')) {
      setESMS(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Tasks')) {
      setETasks(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Jobs')) {
      setJobs(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('OTA')) {
      setOTA(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Billing')) {
      setBillIt(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Tasks')) {
      setEnableTasks(true);
    }
    if (data && data.role && data.role.organizations && data.role.organizations.permissions.includes('Recordings')) {
      setRecordings(true);
    }
    if (data && data.role && data.role.roles && data.role.roles.permissions.includes('Boss')) {
      setBoss(true);
    }
  }, [data]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const otaFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/otas?${query}&status=${boss}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });

      // set state when the data received
      setOtaData(mydata.ota);
    };
    otaFetch();
  }, [loading]);

  const header = () => (
    <div><h1>Edit Task List</h1></div>
  );
  const headerSMS = () => (
    <div><h1>Edit Available SMS List</h1></div>
  );
  let dialogInstance;
  function dialogOK(f, e) {
    dialogInstance.hide();
  }
  const billingExport = async (row) => {
    let billingId = 'all';
    if (row && row.length > 0 && row[0]._id && row[0]._id.length > 0) {
      usr.organizationid = row[0]._id;
      billingId = 'parent';
    }
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}&billingid=${billingId}`;
    const mydata = await (
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
    ).json()
      .catch((err) => {
        console.error('Error parsing JSON:', err);
        return null;
      });
    if (mydata && mydata.response) {
      DialogUtility.alert(mydata.response);
    } else {
      console.error(mydata);
    }
  };
  const handleCfgDialogClick = () => {
    setCfgDialog(!cfgDialog);
  };

  const cfgbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleCfgDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },

  ];
  const handleSSDialogClick = () => {
    setSSDialog(!ssDialog);
  };

  const ssbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleSSDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const handleInvDialogClick = () => {
    setInvDialog(!invDialog);
  };
  const handleSMSDialogClick = () => {
    setSMSDialog(!smsDialog);
  };
  const invbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        if (inventory && inventory.length > 0) {
          dialogClick('map', 'Inventory handler', `Would you like to map ${organization.title} Organization's inventory MSN to Band ID?`, organization);
        } else {
          dialogClick('na', 'Inventory handler', `No inventory in ${organization.title}!`, null);
        }
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        iconCss: 'e-icons e-sorting-2',
        content: 'Map',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleInvDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const smsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleSMSDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  function dialogClick(f, hdr, content, e) {
    // setIsClicked('profile', false);
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogMapInv(f, e); } };
      if (grid && grid.current) {
        const selectedRow = grid.current.getSelectedRecords()[0];
        if (!selectedRow) {
          dialogClick('na', 'Inventory Map', 'No organization selected', null);
          return;
        }
      }
    }
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  function dialogMapInv(f, e) {
    dialogInstance.hide();
    if (!inventory || inventory.length === 0) {
      dialogClick('na', 'Inventory handler', 'No inventory available to assign to Arm Bands!', null);
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/inventory?map=true`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(e),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        dialogClick('na', 'Inventory handler', responseJson.response, null);
        setReLoadInventory(!reloadInventory);
        setInvDialog(!invDialog);
      })
      .catch((error) => {
        dialogClick('na', 'Inventory handler error', error, null);
      });
  }
  const dropDownListObject = useRef(null);

  const removeTask = () => {
    const nt = document.getElementById('newtask').value;
    const orig = taskData.length;
    const updatedData = taskData.filter((item) => item.text !== nt);
    setTaskData(updatedData);
    dropDownListObject.current.dataSource = updatedData;
    // dropdownInstance.dataBind();
    if (orig > updatedData.length) {
      dialogClick('na', 'Task Data', `Item ${nt} successfully removed, please remember to save your changes!`, null);
    }
  };

  const handleTaskChange = () => {
    const nt = document.getElementById('newtask').value;
    let rtn = false;
    taskData.forEach((e, index) => {
      if (nt === e.text) {
        dialogClick('na', 'Task Data', `Item ${nt} already exists, please enter a unique task name!`, null);
        rtn = true;
      }
    });
    if (rtn) {
      return;
    }
    const newItem = { id: nt.toLocaleLowerCase(), text: nt };
    setTaskData([...taskData, newItem]);
    if (dropDownListObject && dropDownListObject.current) {
      dropDownListObject.current.addItem(newItem);
      dialogClick('na', 'Task Item added!', `${nt} has been added! Please remember to save your changes!`, null);
      document.getElementById('newtask').value = '';
    }
  };
  const saveTaskList = () => {
    setDialog(!hideDialog);
    // if (!taskData || taskData.length === 0) {
    //  dialogClick('na', 'Task List', 'Please add at least one task item!', null);
    //  return;
    // }
    if (!grid || !grid.current) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords()[0];
    selectedRecords.tasks = taskData;
    fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(selectedRecords),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'Task save failed', `${responseJson.response}`, null);
          return;
        }
        setNewTask('');
        setReload(!reload);
      })
      .catch((error) => {
        dialogClick('na', 'Task save error', `${error}`, null);
      });
  };

  function rowClicked(args) {
    if (args && args.column && args.column.field && args.column.field === 'ota') {
      return;
    }
    if (grid && grid.current && args && args.rowData) {
      const selectedRecords = args.rowData;
      setDisabledRemove(true);
      setOrganization(selectedRecords);
      setLoadInventory(selectedRecords._id);
      if (selectedRecords.tasks && selectedRecords.tasks.length > 0) {
        setTaskData(selectedRecords.tasks);
      } else {
        setTaskData([]);
      }
    }
  }
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        removeTask();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        disabled: disabledRemove,
        content: 'REMOVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleTaskChange();
        setDisabledRemove(true);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveTaskList();
        setDisabledRemove(true);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: false,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        if (!grid || !grid.current) {
          return;
        }
        const selectedRecords = grid.current.getSelectedRecords()[0];
        if (selectedRecords && selectedRecords.tasks !== taskData) {
          dialogClick('na', 'Task Data has changed', 'Save changes, before exiting, or press the X (Close) to discard changes!', null);
          return;
        }
        setDialog(!hideDialog);
        setDisabledRemove(true);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const cfgTemplate = () => (
    <Configuration dt={organization} />
  );
  const smsTemplate = () => (
    <SMS organization={organization} orgs={parentOrgs} />
  );
  const ssTemplate = () => (
    <Spreadsheet dt={organization} />
  );
  const invTemplate = () => (
    <InventoryContent dt={inventory} />
  );

  const taskTemplate = () => (
    <div className={`m-2 md:m-4 mt-4 p-2 md:p-10 bg-white rounded-3xl${isMobile ? ' w-full min-w-0' : ''}`}>
      <DropDownListComponent
        id="tasklist"
        dataSource={taskData}
        ref={dropDownListObject}
        sortOrder="Ascending"
        popupHeight="200px"
        value={taskData}
        readOnly
        fields={{ text: 'text', value: 'id' }}
        placeholder="Task List"
        onChange={(v) => { document.getElementById('newtask').value = v.target.itemData.text; setDisabledRemove(false); }}
      />
      <TextBoxComponent
        placeholder="Add new task"
        value=""
        width={isMobile ? '100%' : '250px'}
        required
        id="newtask"
        showClearButton
        cssClass="e-outline"
        floatLabelType="Never"
        onChange={(v) => { if (v.value.length === 0) { setNewTask(''); } else { setNewTask(v.value); } }}
      />
    </div>
  );

  useEffect(() => {
    if (collapseConfiguration === true) {
      setCfgDialog(!cfgDialog);
      setReload(!reload);
    }
  }, [collapseConfiguration]);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      setLoading(true);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      if (mydata) {
        if (mydata.user && mydata.user.preferences && mydata.user.preferences.organizations) {
          if (mydata.user.preferences.organizations.group && !isMobile) {
            setGroups(mydata.user.preferences.organizations.group);
          } else {
            setGroups([]);
          }
          if (mydata.user.preferences.organizations.sort && mydata.user.preferences.organizations.sort[0].direction && !isMobile) {
            const mysortedColumns = { columns: mydata.user.preferences.organizations.sort };
            setSortColumns(mysortedColumns);
          }
        } else {
          setGroups([]);
        }
        // set state when the data received
        setData(mydata);
        if (mydata.categories) {
          setCategoryData(mydata.categories);
        }
        setOrgs(mydata.organization);
        setLoading(false);
        if (grid && grid.current) {
          grid.current.refresh();
        }
      }
    };
    dataFetch();
  }, [reload, isMobile, parentOrgs]);
  useEffect(() => {
    // limit associates to the overall selection
    if (loadInventory === '') {
      return;
    }
    usr.specific = 'true';
    usr.organizationid = loadInventory;
    // fetch data
    const invFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      // set state when the data received
      setInventory(mydata.inventory);
    };
    invFetch();
  }, [loadInventory, reloadInventory]);

  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };

  const clickHandler = (args) => {
    if (!grid || !grid.current) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (grid && grid.current && selectedRecords[0] && selectedRecords[0].length > 0) {
      setOrganization(selectedRecords[0]);
      setLoadInventory(selectedRecords[0]._id);
      if (selectedRecords[0].tasks && selectedRecords[0].tasks.length > 0) {
        setTaskData(selectedRecords[0].tasks);
      } else {
        setTaskData([]);
      }
    }
    if (grid && grid.current && args.item.properties.text === 'Recordings') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Recordings', 'Please select an Organization', null);
      } else {
        navigate('../recordings');
      }
    } else if (grid && grid.current && args.item.properties.text === 'OTA') {
      navigate('../ota');
    } else if (grid && grid.current && args.item.properties.text === 'Jobs') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Jobs edit', 'Please select an Organization', null);
      } else {
        navigate(`../jobs?id=${selectedRecords[0]._id}&name=${selectedRecords[0].title}`);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Tasks') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Jobs edit', 'Please select an Organization', null);
      } else {
        setDialog(!hideDialog);
      }
    } else if (args.item.properties.text === 'Configuration') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Configuration handler', 'Please select an organization!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setCollapseConfiguration(false);
        setCfgDialog(!cfgDialog);
      } else {
        dialogClick('na', 'Configuration handler', 'Please select only one organization!', null);
      }
    } else if (args.item.properties.text === 'Job Board') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'SpreadSheet handler', 'Please select an organization!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setSSDialog(!ssDialog);
      } else {
        dialogClick('na', 'SpreadSheet handler', 'Please select only one organization!', null);
      }
    } else if (args.item.properties.text === 'SMS') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'SMS handler', 'Please select an organization!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        setSMSDialog(!smsDialog);
      } else {
        dialogClick('na', 'SMS handler', 'Please select only one organization!', null);
      }
    } else if (args.item.properties.text === 'Inventory') {
      if (!selectedRecords || selectedRecords.length === 0) {
        dialogClick('na', 'Inventory handler', 'Please select an organization!', null);
      } else if (selectedRecords && selectedRecords.length === 1) {
        // dialogClick('map', 'Inventory handler', `Would you like to map ${selectedRecords[0].title} Organization's inventory MSN to Band ID?`, selectedRecords[0]);
        // dialogClick('map', 'Inventory handler', null, selectedRecords[0]);
        setInvDialog(!invDialog);
      } else {
        dialogClick('na', 'Inventory handler', 'Please select only one organization!', null);
      }
    } else if (grid && grid.current && args.item.properties.text === 'Billing Export') {
      billingExport(selectedRecords);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Organizations_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Add') {
      grid.current.addRecord();
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      grid.current.startEdit(selectedRecords[0]);
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      args.cancel = true;
      grid.current.deleteRecord(selectedRecords[0]);
    }
  };
  const actionComplete = (args) => {
    const editedData = args.data;
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.title}`;
      }
    }

    const cols = grid.current.columns;
    for (const col of cols) {
      if (col.headerText === 'Image') {
        col.allowEditing = false;
      }
    }
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      args.form.elements.namedItem('title').focus();
      const dialog = { args };
      if (dialog) {
        dialog.header = `Details of ${args.rowData.title}`;
        dialog.width = '50vw';
      }
    } else if (args.form && args.requestType === 'add') {
      // args.form.elements.namedItem('title').focus();
    } else if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        // The default edit operation is cancelled
        if (!editedData.parent && selectedOrg && selectedOrg.id && selectedOrg.id.length > 0 && selectedOrg.name && selectedOrg.name.length > 0) {
          editedData.parent._id = selectedOrg.id;
          editedData.parent.name = selectedOrg.name;
        } else {
          parentOrgs.forEach((element) => {
            if (element._id == editedData.parent._id) {
              editedData.parent._id = element._id;
              editedData.parent.name = element.title;
            }
          });
        }
        if (!editedData.parent || !editedData.parent._id || editedData.parent._id.length === 0) {
          args.cancel = true;
          DialogUtility.alert('Please choose a parent organization!');
          return;
        }
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Organization add failed');
              args.cancel = true;
              return;
            }
            dialogClick('na', 'Organization insert', editedData.title, null);
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }

            // setReload(!reload);
          })
          .catch((error) => {
            console.error('Org Insert', error);
            args.cancel = true;
            DialogUtility('Organization insert error');
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        if (args.previousData && args.previousData.parent && args.previousData.parent._id && editedData.parent
          && editedData.parent._id && args.previousData.parent._id !== editedData.parent._id && !boss) {
          args.cancel = true;
          setReload(!reload);
          DialogUtility.alert(`Parent organization is already assigned to ${editedData.parent.name}!`);
          return;
        }
        parentOrgs.forEach((element) => {
          if (element._id == editedData.parent._id) {
            editedData.parent._id = element._id;
            editedData.parent.name = element.title;
          }
        });
        if (selectedOrg && (!editedData.parent || !editedData.parent._id || editedData.parent._id.length === 0)) {
          editedData.parent._id = selectedOrg.id;
          editedData.parent.name = selectedOrg.name;
        }
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
            }
            dialogClick('na', 'Organization update', responseJson.response, null);
            setReload(!reload);
          })
          .catch((error) => {
            dialogClick('na', 'Organization update error', error, null);
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Organization delete', responseJson.response, null);
              setReload(!reload);
              args.cancel = true;
              return;
            }
            dialogClick('na', 'Organization delete', responseJson.response, null);
          })
          .catch((error) => {
            console.error('Org Delete', error);
            dialogClick('na', 'Organization delete error', error, null);
            args.cancel = true;
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.organizations) {
      data.user.preferences.organizations = {};
    }
    if (pref === 'group') {
      data.user.preferences.organizations = { group: val, sort: data.user.preferences.organizations.sort };
    } else if (pref === 'sort') {
      data.user.preferences.organizations = { group: data.user.preferences.organizations.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          dialogClick('na', 'Organization User preference update', responseJson.response, null);
        }
      })
      .catch((error) => {
        dialogClick('na', 'Organization user preferences update error', error, null);
      });
  }
  const actionBegin = (args) => {
    if (args.requestType == 'beginEdit' && args.rowData._id === usr.organizationid && !boss) {
      DialogUtility.alert('Please contact your Zackat Labs service representative to adjust your organization settings!');
      args.cancel = true;
      return;
    }
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
    if (grid && grid.current) {
      const cols = grid.current.columns;
      for (const col of cols) {
        if (col.headerText === 'Image') {
          col.allowEditing = false;
        }
        if (args.requestType == 'beginEdit') {
          if (col.headerText == 'Address' || col.headerText == 'City' || col.headerText == 'State' || col.headerText == 'Zip') {
            col.visible = true;
            args.rowData.organization = args.rowData.parent.name;
          }
          if (col.headerText == 'Parent') {
            col.visible = false;
            col.allowEditing = true; // boss;
          }
          if (col.headerText == 'Organization') {
            col.visible = false;
          }
        }
        if (args.requestType == 'add') {
          if (col.headerText == 'Address' || col.headerText == 'City' || col.headerText == 'State' || col.headerText == 'Zip') {
            col.visible = true;
          }
          if (col.headerText == 'Organization') {
            col.visible = false;
          }
          if (col.headerText == 'Parent') {
            col.visible = true;
          }
        } else {
          if (col.headerText == 'Organization' || col.headerText == 'Address' || col.headerText == 'City' || col.headerText == 'State' || col.headerText == 'Zip') {
            col.visible = true;
          }
          if (col.headerText == 'Organization') {
            col.visible = false;
          }
          if (col.headerText == 'Parent') {
            col.visible = true;
          }
        }
      }
    }
  };
  const recordings = { text: 'Recordings', tooltipText: 'Canned Recordings', prefixIcon: 'e-expand', id: 'recordings', visible: boss || enableRecordings };
  const otas = { text: 'OTA', tooltipText: 'OTA bin files', prefixIcon: 'e-fit-100', id: 'ota', visible: boss };
  const jobs = { text: 'Jobs', tooltipText: 'Jobs', prefixIcon: 'e-table-insert-column', id: 'jobs', visible: boss || enableJobs };
  const add = { text: 'Add', tooltipText: 'Add Organization', prefixIcon: 'e-add', id: 'add', visible: boss || crudCreate, disabled: false };
  const edit = { text: 'Edit', tooltipText: 'Edit Organization', prefixIcon: 'e-edit', id: 'edit', visible: boss || crudUpdate, disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete Organization', prefixIcon: 'e-delete-2', id: 'delete', visible: boss || crudDelete, disabled: false };
  const tasks = { text: 'Tasks', tooltipText: 'Job Tasks', prefixIcon: 'e-more-vertical-3', id: 'tasks', visible: boss || enableTasks };
  const cfg = { text: 'Configuration', tooltipText: 'Configuration', visible: boss || config, prefixIcon: 'e-settings', id: 'config' };
  const ss = { text: 'Job Board', tooltipText: 'Job Board', visible: development, prefixIcon: 'e-timeline-week', id: 'board' };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const billing = { text: 'Billing Export', tooltipText: 'Billing Export', prefixIcon: 'e-export-excel', id: 'billing', visible: boss || billit, disabled: false };
  const inv = { text: 'Inventory', tooltipText: 'Inventory Mapping', visible: boss || band, prefixIcon: 'e-sorting-1', id: 'inv' };
  const sms = { text: 'SMS', tooltipText: 'SMS', visible: boss || esms, prefixIcon: 'e-field-settings', id: 'sms' };

  const toolbarOptions = ['Search', add, edit, del, recordings, otas, jobs, ss, tasks, cfg, sms, inv, excel, billing];
  const toolbarNoOptions = ['Search', add, edit, del];

  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };

  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Normal',
  };
  const typeGrid = (props) => (
    <div>
      <DropDownListComponent
        id="ota"
        dataSource={otaData}
        fields={{ value: '_id', text: 'name' }}
        value={props.ota}
      />
    </div>
  );
  let dialogObj;
  function cancelClick() {
    // Logic to perform when the user clicks 'Cancel'
    setReload(!reload);
    dialogObj.hide(); // Closes the dialog
  }
  const updateOta = (org, ota) => {
    dialogObj.hide();
    fetch(`${REACT_APP_API_ENDPOINT}/organizations`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(org),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert('Organization OTA Action, An error has occured during Update!');
        } else {
          DialogUtility.alert('Organization OTA Action, Updated!');
          // setReload(!reload);
        }
      })
      .catch((error) => {
        DialogUtility.alert('Organization OTA Action, error!');
      });
  };

  const handleTypeChange = (args) => {
    if (args && args.itemData) {
      data.organization.forEach((a, index) => {
        if (a._id === args.element.id) {
          data.organization[index].ota = args.value;
          dialogObj = DialogUtility.confirm({
            title: 'OTA Confirmation',
            content: `Confirm, do you want to assign ${args.itemData.name} to ${data.organization[index].title}?`,
            cancelButton: { text: 'Cancel', click: cancelClick },
            okButton: {
              text: 'OK',
              click: () => updateOta(data.organization[index], args.itemData.name),
            },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Zoom' }, // Optional: add animation
          });
        }
      });
    }
  };
  const typeTemplateGrid = (props) => (
    <div>
      <DropDownListComponent
        id={props._id}
        dataSource={otaData}
        fields={{ value: '_id', text: 'name' }}
        value={props.ota}
        change={handleTypeChange}
        placeholder="Select OTA"
      />
    </div>
  );

  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    const result = parentOrgs.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.id || result._id === '') {
      args.cancel = true;
      dialogClick('na', 'Organization Import', 'Please select an organization', null);
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  };
  function completeUpload(args) {
    DialogUtility.alert(`Upload Completed ${args.fileData[0].status}`);
    // dialogClick('na', 'Organization Import ', 'Upload complete!', null);
    setReload(!reload);
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/organizationsremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/organizationsupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };

  const FilterOptions = {
    type: 'FilterBar',
    showFilterBarStatus: true,
    mode: 'Immediate',
  };
  const currentThemeColor = localStorage.getItem('colorMode');
  if (loading) {
    return <p>Loading... </p>;
  }
  /*
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
*/
  if (!data.role.organizations.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  //  to="https://scribehow.com/viewer/Add_Organization_and_Import_Devices__-qjnqumPQ_euMEDXM4B-AQ?referrer=workspace"

  const wrapAdaptiveGrid = (gridEl) => {
    if (!gridEl) {
      return null;
    }
    return (
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {gridEl}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={!isMobile ? 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh max-w-full overflow-x-hidden' : 'bg-white rounded-3xl zackat-divalh w-full mt-44 max-w-full overflow-x-hidden'}>
      <div className="flex">
        <Link
          className="my-link"
          to="/pdf/organization.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Administration" title="Organizations" />
        {!isMobile && (
          <div style={{ position: 'absolute', right: 0 }} className="mr-4">
            <Link
              to="/orgchart"
              className="bgxprnt"
            >
              <img className="bgxprnt" src={orgchart} width={60} height={45} />
            </Link>
          </div>
        )}
      </div>
      {!isMobile && (
        <div style={{
          backgroundColor: currentThemeColor,
          textAlign: 'right',
          marginTop: '-40px',
        }}
        >
          <div id="droparea" className="flex mb-8">
            {!loading && crudImport && (
              <div className="control-section accordion-control-section" style={{ width: '45%' }}>
                <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                  <AccordionComponent>
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                      <div className="e-input-group">
                        <div className="mt-4"> Import </div>
                      </div>
                      <div className="mt-2 e-input-group">
                        <div>
                          <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={orgs} fields={{ value: '_id', text: 'title' }} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                        </div>
                        <UploaderComponent
                          id="fileupload"
                          type="file"
                          ref={(uplaod) => { uploadObj = uplaod; }}
                          asyncSettings={path}
                          buttons={buttons}
                          multiple={false}
                          actionComplete={completeUpload}
                          autoUpload={false}
                          uploading={onFileUpload}
                          allowedExtensions=".csv"
                        />
                      </div>
                    </div>
                  </AccordionComponent>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {!loading && data && data.organization && orgs && wrapAdaptiveGrid(
        <GridComponent
          ref={grid}
          id="orggridcomp"
          dataSource={orgs}
          allowPaging
          pageSettings={{ pageSize: 20, pageCount: 10 }}
          width="100%"
          allowSorting={!isMobile}
          contextMenuItems={contextMenuItems}
          editSettings={isMobile ? editingMobile : editing}
          toolbar={!isMobile ? toolbarOptions : toolbarNoOptions}
          toolbarClick={clickHandler}
          dataBound={dataBound}
          allowResizing
          enableStickyHeader={!isMobile}
          allowGrouping={!isMobile}
          allowExcelExport
          groupSettings={groupOptions}
          sortSettings={sortOptions}
          // allowFiltering={data && data.organization && data.organization.length > 0}
          filterSettings={FilterOptions}
          actionComplete={actionComplete}
          actionBegin={actionBegin}
          recordClick={rowClicked}
          allowTextWrap
          enableAdaptiveUI={isMobile}
          rowRenderingMode={zRenderMode}
          enableAltRow
          enablePersistence
        >
          <ColumnsDirective>
            <ColumnDirective field="title" headerText="Customer Name" width="150" validationRules={valuerules} textAlign="Left" />
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            {/* {organizationsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)} */}
            <ColumnDirective
              field="_id"
              headerText="ID"
              textAlign="Left"
              width="120"
              visible={false}
              isPrimaryKey
            />
            <ColumnDirective
              field="desc"
              headerText="Location"
              textAlign="Left"
              allowSorting={false}
              width="150"
              template={gridLatLngOrganization}
              visible={!isMobile}
            />
            <ColumnDirective
              field="address"
              headerText="Address"
              textAlign="Left"
              width="150"
              visible={!isMobile}
            />
            <ColumnDirective
              field="city"
              headerText="City"
              textAlign="Left"
              width="150"
              visible={!isMobile}
            />
            <ColumnDirective
              field="state"
              headerText="State"
              textAlign="Left"
              width="150"
              visible={!isMobile}
            />
            <ColumnDirective
              field="zip"
              headerText="Zip"
              textAlign="Left"
              width="150"
              visible={!isMobile}
            />
            <ColumnDirective
              field="phone"
              headerText="Phone"
              textAlign="Left"
              width="150"
              visible={!isMobile}
            />
            {categoryData && categoryData.length > 0
              && (
                <ColumnDirective
                  field="category"
                  headerText="Category"
                  width="100"
                  visible={boss && !isMobile}
                  editType="dropdownedit"
                  foreignKeyField="_id"
                  foreignKeyValue="model"
                  dataSource={categoryData}
                  allowSorting
                />
              )}
            {otaData && otaData.length > 0
              && (
                <ColumnDirective
                  field="ota"
                  headerText="OTA (ZH2506-01)"
                  width="150"
                  visible={!isMobile}
                  editType="dropdownedit"
                  foreignKeyField="_id"
                  foreignKeyValue="name"
                  // validationRules={valuerules}
                  dataSource={otaData}
                  allowSorting={false}
                  editTemplate={typeGrid}
                  template={typeTemplateGrid}
                />
              )}
            <ColumnDirective
              field="parent._id"
              headerText="Parent"
              width="150"
              visible={!isMobile}
              editType="dropdownedit"
              validationRules={valuerules}
              foreignKeyField="_id"
              foreignKeyValue="title"
              allowSorting={false}
              dataSource={parentOrgs}
            />
          </ColumnsDirective>
          <Inject services={[Search, Page, Edit, Toolbar, Filter, Sort, ContextMenu, ExcelExport, Resize, ForeignKey, Group, LazyLoadGroup]} />
        </GridComponent>,
      )}
      {organization && !cfgDialog && (
        <DialogComponent
          header="Configuration"
          content={cfgTemplate}
          buttons={cfgbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setCfgDialog(!cfgDialog); }}
          close={() => { setCfgDialog(!cfgDialog); }}
        />
      )}
      {organization && !ssDialog && (
        <DialogComponent
          header="Job Board"
          content={ssTemplate}
          buttons={ssbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setSSDialog(!ssDialog); }}
          close={() => { setSSDialog(!ssDialog); }}
        />
      )}
      {!invDialog && (
        <DialogComponent
          header={`${organization.title} Arm Band ID Mapping to MSN`}
          content={invTemplate}
          buttons={invbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setInvDialog(!invDialog); }}
          close={() => { setInvDialog(!invDialog); }}
        />
      )}

      {!hideDialog && (
        <DialogComponent
          header={header}
          content={taskTemplate}
          buttons={addbuttons}
          width={isMobile ? '95%' : '35%'}
          height={isMobile ? '80%' : '40%'}
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setTaskData(organization.tasks); setDialog(!hideDialog); }}
          close={() => { setTaskData(organization.tasks); setDialog(!hideDialog); }}
        />
      )}
      {!smsDialog && organization && (
        <DialogComponent
          header={headerSMS}
          content={smsTemplate}
          buttons={smsbuttons}
          width={isMobile ? '95%' : '65%'}
          height="80%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setSMSDialog(!smsDialog); }}
          close={() => { setSMSDialog(!smsDialog); }}
        />
      )}
    </div>
  );
};
export default Organizations;
